import { useMutation } from "@apollo/client";

import { ProcessPublicTokenMutation, ProcessPublicTokenMutationVariables } from "@ctypes";
import { PROCESS_PUBLIC_TOKEN, USER } from "@graphql";

export const useProcessBankLinkToken = () => {
  return useMutation<ProcessPublicTokenMutation, ProcessPublicTokenMutationVariables>(
    PROCESS_PUBLIC_TOKEN,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
